import React from "react";

/**
 * SOUND-643 — status pill for CRM records.
 *
 * Same construction as components/Tickets/TicketStatusPill (badge tone + leading
 * dot), but takes its tone map as a prop. Ticket, MID, MID-application and
 * registration vocabularies share key names while meaning different things, so
 * the map stays with the entity — see utilities/statusTones.
 */
export default function RecordStatusPill({ status, toneFor, className = "" }) {
  const { label, badge, dot } = toneFor(status);
  return (
    <span className={`badge ${badge} ${className}`} title={`Status: ${label}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} aria-hidden="true" />
      {label}
    </span>
  );
}
